import {
  contractMakerHostRedirect,
  prefetchContractMakerLibrary,
} from "@dashboard/lib/contracts/contract-maker-route"
import { LazyDashboardApp } from "@dashboard/routes/lazy-dashboard-app"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { DashboardShellSkeleton } from "@ui-dashboard/DashboardShellSkeleton"
import { Suspense } from "react"

export const Route = createFileRoute("/dashboard/contract-maker/$")({
  component: DashboardContractMakerSplatRoute,
  beforeLoad: async ({ location }) => {
    const redirectHref = await contractMakerHostRedirect(location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
  /**
   * This route had no loader, and it is the one that most needed one.
   *
   * Contract Maker pulls the largest chunk in the dashboard, and with nothing
   * started here the sequence was strictly serial: commit, download the chunk,
   * mount, and only then ask for the library. The content sections start their
   * chunk and their data together, which is most of why they feel different.
   *
   * Nothing is awaited in the browser, for the same reason as the section
   * route: a loader that waits holds the old page on screen. The server waits,
   * because there the wait is what puts the rows in the HTML.
   */
  loader: async ({ context, location }) => {
    if (typeof window !== "undefined") {
      void import("@dashboard/routes/DashboardApp")
      void import("@dashboard/components/contracts/ContractsWorkspace")
    }

    const library = prefetchContractMakerLibrary(context.queryClient, location)
    if (typeof window === "undefined") await library

    return null
  },
})

function DashboardContractMakerSplatRoute() {
  return (
    <Suspense fallback={<DashboardShellSkeleton />}>
      <LazyDashboardApp activeSection="contractMaker" />
    </Suspense>
  )
}
